module.exports = __webpack_public_path__ + "static/media/UIUC_Research.83b7d47b.PNG";